import {
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  forwardRef,
  useMemo,
} from "react";
import { findWhere } from "underscore";

import SelectableInput from "../../../components/SelectableInput/SelectableInput";
import useGlobalList from "../../../api/api-hooks/cloud/useGlobalListByName";

const SingleSelect = ({ field, value, onChange, disabled }, ref) => {
  const listName = useMemo(() => {
    if (!field?.SourcesList.includes("Global.Lists.")) return "";

    return field?.SourcesList.split(".")[2];
  }, [field?.SourcesList]);

  const { list, loading } = useGlobalList(listName);
  const selectRef = useRef();
  const [selectedRecord, setSelectedRecord] = useState(value);
  const handleSelect = (newVal) => {
    setSelectedRecord(newVal);
    onChange(newVal?.Value);
  };

  const handleDeselect = () => {
    setSelectedRecord(null);
    onChange(null);
  };

  const handleOnClear = () => {
    setSelectedRecord(null);
    onChange(null);
  };

  useEffect(() => {
    if (field?.SourcesList.includes("Global.Lists")) {
      field.SourcesList = list?.Variables || [];
    }
    const foundOption = findWhere(field?.SourcesList, { Value: value });
    setSelectedRecord(foundOption);
  }, [field?.SourcesList, value, list]);

  useImperativeHandle(ref, () => ({
    focus: () => selectRef.current.focus(),
  }));

  return (
    <SelectableInput
      ref={selectRef}
      options={field?.SourcesList}
      labelKey="Name"
      valueKey="Value"
      colorKey="Color"
      value={selectedRecord}
      onSelect={handleSelect}
      onDeselect={handleDeselect}
      onClear={handleOnClear}
      field={field}
      isSensitive={field?.Sensitive ?? false}
      disabled={disabled}
      sort={false}
    />
  );
};

export default forwardRef(SingleSelect);
